var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.638,
    height: 10.631,
    viewBox: "0 0 10.638 10.631",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Draft",
    transform: "translate(-127.002 -332.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "edit_FILL1_wght400_GRAD0_opsz48",
    d: "M15.782,8.081,13.924,6.223l.61-.61a.813.813,0,0,1,.617-.239.862.862,0,0,1,.617.254l.624.624a.876.876,0,0,1,0,1.219Zm-.61.61L7.858,16.005H6V14.147l7.314-7.314Z",
    transform: "translate(121.002 327.311)",
    fill: "#9bacb1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraft);
export default __webpack_public_path__ + "static/media/draft.99372b14c433126bad2b20f64fa367c3.svg";
export { ForwardRef as ReactComponent };